module.exports = __webpack_public_path__ + "static/media/logo.add51ef7.png";